/* EFL Wishlist — localStorage-based */
(function() {
  var STORAGE_KEY = 'efl_wishlist';
  
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }
  
  function saveWishlist(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
    updateCounts();
  }
  
  function isInWishlist(handle) {
    return getWishlist().some(function(item) { return item.handle === handle; });
  }
  
  function addToWishlist(handle, title, image, price, url) {
    var list = getWishlist();
    if (!list.some(function(i) { return i.handle === handle; })) {
      list.push({ handle: handle, title: title, image: image, price: price, url: url, added: Date.now() });
      saveWishlist(list);
    }
  }
  
  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function(i) { return i.handle !== handle; });
    saveWishlist(list);
  }
  
  function toggleWishlist(handle, title, image, price, url) {
    if (isInWishlist(handle)) { removeFromWishlist(handle); return false; }
    else { addToWishlist(handle, title, image, price, url); return true; }
  }
  
  function updateCounts() {
    var count = getWishlist().length;
    document.querySelectorAll('.efl-wishlist-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('.efl-wishlist-btn').forEach(function(btn) {
      var handle = btn.getAttribute('data-handle');
      if (handle && isInWishlist(handle)) {
        btn.classList.add('efl-wishlist-btn--active');
      } else {
        btn.classList.remove('efl-wishlist-btn--active');
      }
    });
  }
  
  // Auto-add wishlist buttons to product cards
  function addButtons() {
    document.querySelectorAll('.product-card').forEach(function(card) {
      if (card.querySelector('.efl-wishlist-btn')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href');
      var handleMatch = href.match(/\/products\/([^?#\/]+)/);
      if (!handleMatch) return;
      var handle = handleMatch[1];
      
      var title = '';
      var titleEl = card.querySelector('.product-card__title');
      if (titleEl) title = titleEl.textContent.trim();
      
      var img = '';
      var imgEl = card.querySelector('.product-card__image--main img');
      if (imgEl) img = imgEl.src || '';
      
      var price = '';
      var priceEl = card.querySelector('.price');
      if (priceEl) price = priceEl.textContent.trim();
      
      var btn = document.createElement('button');
      btn.className = 'efl-wishlist-btn';
      btn.setAttribute('data-handle', handle);
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        var added = toggleWishlist(handle, title, img, price, '/products/' + handle);
        btn.classList.toggle('efl-wishlist-btn--active', added);
      };
      
      if (isInWishlist(handle)) btn.classList.add('efl-wishlist-btn--active');
      
      var imgWrapper = card.querySelector('.product-card__image-wrapper');
      if (imgWrapper) imgWrapper.appendChild(btn);
    });
  }
  
  // Render wishlist page
  function renderWishlistPage() {
    var container = document.getElementById('efl-wishlist-grid');
    if (!container) return;
    
    var list = getWishlist();
    if (list.length === 0) {
      container.innerHTML = '<div class="efl-wishlist-empty"><p>Your wishlist is empty.</p><a href="/collections" class="btn btn--primary">Browse Collections</a></div>';
      return;
    }
    
    var html = '';
    list.forEach(function(item) {
      html += '<div class="efl-wishlist-item">';
      html += '<a href="' + item.url + '" class="efl-wishlist-item__image"><img src="' + (item.image || '') + '" alt="' + item.title + '" loading="lazy"></a>';
      html += '<div class="efl-wishlist-item__info">';
      html += '<h3><a href="' + item.url + '">' + item.title + '</a></h3>';
      if (item.price) html += '<p class="efl-wishlist-item__price">' + item.price + '</p>';
      html += '<button class="efl-wishlist-remove btn btn--secondary" data-handle="' + item.handle + '">Remove</button>';
      html += '</div></div>';
    });
    container.innerHTML = html;
    
    container.querySelectorAll('.efl-wishlist-remove').forEach(function(btn) {
      btn.onclick = function() {
        removeFromWishlist(btn.getAttribute('data-handle'));
        renderWishlistPage();
      };
    });
  }
  
  // Init
  document.addEventListener('DOMContentLoaded', function() {
    updateCounts();
    addButtons();
    renderWishlistPage();
  });
  
  // Watch for new cards (infinite scroll)
  new MutationObserver(function() { addButtons(); }).observe(
    document.body, { childList: true, subtree: true }
  );
  
  window.eflWishlist = { toggle: toggleWishlist, get: getWishlist, remove: removeFromWishlist };
})();
